import { SHOW_MODAL, HIDE_MODAL, SHOW_CONFIRM, HIDE_CONFIRM } from './../../constants'

export function showModal(type, status, message) {
  return {
    type: SHOW_MODAL,
    modalType: type,
    modalStatus: status,
    modalMessage: message,
  }
}

export function hideModal(type) {
  return {
    type: HIDE_MODAL,
    modalType: type,
  }
}

export function showConfirm(type, status, message) {
  return {
    type: SHOW_CONFIRM,
    modalType: type,
    modalStatus: status,
    modalMessage: message,
  }
}

export function hideConfirm(type) {
  return {
    type: HIDE_CONFIRM,
    modalType: type,
  }
}



// WEBPACK FOOTER //
// ./src/actions/modal/modal-action.js